<template>
  <div class="page">
    <!-- 顶部导航 -->
    <header class="topbar" :class="{ scrolled: showScrollToTop }">
      <div class="topbar-inner">
        <a class="brand" href="/" @click.prevent="scrollToTop">
          <img class="brand-mark" src="/favicon.png" alt="" />
          <span class="brand-copy">
            <span class="brand-text">星空素材网</span>
            <span class="brand-sub">素材资源库</span>
          </span>
        </a>

        <nav class="top-nav" aria-label="主导航">
          <div class="nav-group">
            <button
              type="button"
              class="nav-link"
              @click="openUrl('https://wcnzpw07vo1s.feishu.cn/wiki/TiUtwEAamisbExkBf5mcU3Blnnc?from=from_copylink')"
            >
              漫剧工具
            </button>
            <button
              type="button"
              class="nav-link"
              @click="openUrl('https://wcnn04eeapjz.feishu.cn/wiki/IHtDwhCxPisPnikcsTQcurc5nuf?from=from_copylink')"
            >
              简笔画工具
            </button>
            <button type="button" class="nav-link" @click="goCopyright">
              版权中心
            </button>
          </div>

          <span class="nav-divider" aria-hidden="true"></span>

          <div class="nav-group">
            <template v-if="isUserLogin">
              <button
                type="button"
                class="nav-link"
                @click="openUserCenter"
              >
                用户中心
              </button>
              <button type="button" class="nav-link nav-quiet" @click="tuichu">
                退出
              </button>
            </template>
            <button
              v-else
              type="button"
              class="nav-login"
              @click="loginShow = true"
            >
              登录
            </button>
          </div>

          <span class="nav-divider" aria-hidden="true"></span>

          <div class="theme-switch" v-click-outside="closePanel">
            <button
              type="button"
              class="theme-chip"
              @click="togglePanel"
              aria-label="主题设置"
              :aria-expanded="themeState.panelOpen"
            >
              <span class="theme-chip-dot" aria-hidden="true"></span>
              <span>{{ themeState.isDark ? "夜间" : "白天" }}</span>
            </button>
            <div class="theme-panel" v-show="themeState.panelOpen">
              <div class="theme-row">
                <span>外观</span>
                <button type="button" class="mode-btn" @click="toggleTheme">
                  {{ themeState.isDark ? "切到白天" : "切到夜间" }}
                </button>
              </div>
              <div class="theme-row accents">
                <span>主题色</span>
                <div class="accent-list">
                  <button
                    type="button"
                    class="accent-dot"
                    v-for="item in accentOptions"
                    :key="item.id"
                    :class="{ active: themeState.accent === item.id }"
                    :style="{ background: item.color }"
                    :title="item.name"
                    @click="setAccent(item.id)"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>

    <!-- Hero：品牌 + 一句说明 + CTA + 全幅背景 -->
    <section
      class="hero"
      :style="{ backgroundImage: `url(${backgroundImagePath2})` }"
    >
      <div class="hero-veil"></div>
      <div class="hero-orbit" aria-hidden="true"></div>
      <div class="hero-content">
        <p class="hero-kicker">XING KONG</p>
        <h1 class="hero-title">星空素材网</h1>
        <p class="hero-desc">精美动漫素材，创意新想汇聚</p>
        <div class="hero-actions">
          <button type="button" class="btn-primary" @click="scrollToGallery">
            浏览素材
          </button>
          <button type="button" class="btn-ghost" @click="moneyShow = true">
            立即充值
          </button>
        </div>
      </div>
    </section>

    <!-- 分类 + 搜索 + 列表 -->
    <main class="main" id="gallery">
      <section class="section categories-section">
        <div class="section-head row cat-head">
          <div>
            <h2>素材分类</h2>
            <p>左右滑动选择分类，快速定位人物与场景</p>
          </div>
          <div class="cat-current" v-if="fenleiList[Number(activeIndex)]">
            当前：
            <strong>{{ fenleiList[Number(activeIndex)].name }}</strong>
          </div>
        </div>

        <div class="category-panel">
          <button
            type="button"
            class="cat-arrow cat-arrow-left"
            aria-label="向左滑动"
            @click="scrollCategories(-1)"
          >
            ‹
          </button>
          <div
            class="category-nav-container"
            ref="categoryContainer"
          >
            <div class="category-list">
              <button
                type="button"
                class="category-item"
                v-for="(item, index) in fenleiList"
                :key="item.term_id || index"
                :class="{ active: Number(activeIndex) === index }"
                @click="selectCategory(index, item.term_id)"
              >
                <span class="category-icon-wrap">
                  <img
                    class="category-icon"
                    :src="item.icon"
                    :alt="item.name"
                  />
                </span>
                <span class="category-name">{{ item.name }}</span>
              </button>
            </div>
          </div>
          <button
            type="button"
            class="cat-arrow cat-arrow-right"
            aria-label="向右滑动"
            @click="scrollCategories(1)"
          >
            ›
          </button>
        </div>
      </section>

      <section class="section gallery-section" v-if="Number(activeIndex) !== -1">
        <div class="section-head row">
          <div>
            <h2>素材库</h2>
            <p>输入名称或类型，马上找到可用素材</p>
          </div>
          <div class="searchbox">
            <svg
              class="search-icon"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              aria-hidden="true"
            >
              <path
                fill="currentColor"
                d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
              />
            </svg>
            <input
              v-model="searchValue1"
              type="text"
              placeholder="搜索素材名称 / 类型"
              @keydown.enter="searchSucaiList"
            />
            <button type="button" class="search-btn" @click="searchSucaiList()">
              搜索
            </button>
          </div>
        </div>

        <div class="sucaiList2" v-if="sucaiList.data?.data?.length">
          <article
            class="waterfall_item2"
            v-for="(item, idx) in sucaiList.data.data"
            :key="item.id || idx"
            @click="tuDetail(item)"
          >
            <div class="card-media">
              <el-image
                :src="item.image_cover"
                :fetchpriority="idx < 4 ? 'high' : 'auto'"
                :lazy="idx >= 4"
                :alt="item.post_title"
                :loading="idx < 4 ? 'eager' : 'lazy'"
                class="material-image"
                fit="cover"
              />
              <span
                class="card-tag"
                :class="item.is_model == 2 ? 'vip' : 'normal'"
                v-if="item.post_title"
              >
                {{ item.is_model == 2 ? "VIP" : "素材" }}
              </span>
            </div>
            <h3
              class="card-title"
              :class="{ vip: item.is_model == 2 }"
              v-if="item.post_title"
            >
              {{ item.post_title }}
            </h3>
          </article>
        </div>
        <div class="empty-state" v-else>
          <p>暂无素材，换个关键词或分类试试</p>
        </div>

        <div class="fenye" v-if="sucaiList.data?.last_page > 1">
          <div class="fenye-box">
            <el-pagination
              background
              layout="total, prev, pager, next, jumper"
              :page-size="24"
              :current-page="sucaiList.data.current_page"
              :page-count="sucaiList.data.last_page"
              :total="sucaiList.data.total"
              @current-change="getSucaiList(dqId, $event)"
            />
          </div>
        </div>
      </section>

      <section class="section banner-section" v-else>
        <el-carousel trigger="click" height="420px">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <el-image
              style="width: 100%; height: 100%; object-fit: cover"
              :src="item.url"
              loading="lazy"
              alt=""
            />
          </el-carousel-item>
        </el-carousel>
      </section>
    </main>

    <footer class="site-footer">
      <div class="footer-inner">
        <div class="footer-main">
          <strong class="footer-name">星空素材网</strong>
          <p>高质量简笔画多人物素材，推荐有价值的好东西资源分享</p>
        </div>
        <div class="footer-legal">
          <span>山西壹拾贰网络科技有限公司 版权所有</span>
          <span class="dot" aria-hidden="true">·</span>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noreferrer nofollow"
            >晋ICP备2024033569号-2</a
          >
        </div>
      </div>
    </footer>

    <div class="mengban" v-if="loginShow">
      <div class="loginbox" v-if="isLogin">
        <div class="loginbox_left">
          <div class="login_title">
            <h3>登录</h3>
            <p class="title_minor">
              <em></em>
              <span>Hi~欢迎来到星空素材网</span>
              <em></em>
            </p>
          </div>
          <el-input
            v-model="username"
            class="input_box"
            placeholder="请输入用户名/邮箱"
            @keyup.enter="login_btn"
          >
            <template #prefix>
              <img src="../../src/assets/login/user.png" alt="" />
            </template>
          </el-input>
          <el-input
            v-model="password"
            class="input_box"
            placeholder="请输入密码"
            type="password"
            @keyup.enter="login_btn"
          >
            <template #prefix>
              <img src="../../src/assets/login/password.png" alt="" />
            </template>
          </el-input>

          <div class="login_btn bgcolor" @click="login_btn()">立即登录</div>
          <div class="tishi_btn">抖音昵称及账号在抖音平台不允许修改</div>
          <div class="bottom_box">
            <div class="box_left" @click="isLogin = false">
              没有账号？立即注册
            </div>
            <div class="box_right"></div>
          </div>
        </div>
        <div class="loginbox_right">
          <div class="login-notice">
            <span class="notice-badge">重要的事情说三遍</span>
            <div class="notice-block">
              <h4>素材版权问题</h4>
              <p>
                本素材最终解释权归漫迷文创所有，所有素材均享有国家著作权，付费购买后不意味着拥有此版权，仅拥有个人使用权。
              </p>
            </div>
            <div class="notice-block">
              <h4 class="accent">授权问题</h4>
              <p>
                每个用户可授权 3 个账号使用。如未授权一经发现，将进行法律责任追寻。
              </p>
            </div>
            <div class="notice-tips">
              <p>· 请妥善保管账号，勿分享给未授权人员</p>
              <p>· 抖音昵称及账号在抖音平台不允许修改</p>
              <p>· 付费后仅获得个人使用权，不代表拥有版权</p>
            </div>
          </div>
        </div>
        <img
          class="cha"
          @click="loginShow = false"
          src="../../src/assets/index/cha.png"
          alt=""
        />
      </div>
      <div class="loginbox registerbox" v-else>
        <div class="loginbox_left">
          <div class="login_title">
            <h3>注册账号</h3>
            <p class="title_minor">
              <em></em>
              <span>Hi~欢迎加入星空素材网</span>
              <em></em>
            </p>
          </div>

          <div class="register-fields">
            <el-input v-model="email" class="input_box" placeholder="请输入邮箱">
              <template #prefix>
                <img src="../../src/assets/login/email.png" alt="" />
              </template>
            </el-input>
            <el-input
              v-model="username"
              class="input_box"
              placeholder="请输入用户名"
            >
              <template #prefix>
                <img src="../../src/assets/login/user.png" alt="" />
              </template>
            </el-input>
            <div class="pwd-row">
              <el-input
                v-model="password"
                class="input_box"
                placeholder="请输入密码"
                type="password"
              >
                <template #prefix>
                  <img src="../../src/assets/login/password.png" alt="" />
                </template>
              </el-input>
              <el-input
                v-model="confirm_password"
                class="input_box"
                placeholder="再次输入密码"
                type="password"
              >
                <template #prefix>
                  <img src="../../src/assets/login/password.png" alt="" />
                </template>
              </el-input>
            </div>
          </div>

          <div class="xieyi">
            <input
              v-model="isAgree"
              id="agreement"
              name="agreen"
              type="checkbox"
              class="agreen_btn"
              required=""
            />
            我已阅读并同意
            <a href="#" @click.prevent="agreementShow = true">《注册协议》</a>
          </div>
          <div class="login_btn bgcolor" @click="register_btn()">立即注册</div>

          <div class="bottom_box">
            <div class="box_left" @click="isLogin = true">
              已有账号？立即登录
            </div>
          </div>
        </div>
        <div class="loginbox_right">
          <div class="login-notice">
            <span class="notice-badge">注册前请阅读</span>
            <div class="notice-block">
              <h4>账号说明</h4>
              <p>
                请使用常用邮箱注册，便于找回密码。抖音昵称及账号在抖音平台不允许修改，请按要求完善授权信息。
              </p>
            </div>
            <div class="notice-block">
              <h4>素材版权问题</h4>
              <p>
                本素材最终解释权归漫迷文创所有，所有素材均享有国家著作权，付费购买后仅拥有个人使用权，不代表拥有版权。
              </p>
            </div>
            <div class="notice-block">
              <h4 class="accent">授权问题</h4>
              <p>
                每个用户可授权 3 个账号使用。如未授权一经发现，将进行法律责任追寻。
              </p>
            </div>
          </div>
        </div>
        <img
          class="cha"
          @click="loginShow = false"
          src="../../src/assets/index/cha.png"
          alt=""
        />
      </div>
    </div>

    <div v-if="showAnnouncement" class="announcement-modal">
      <div class="modal-overlay" @click="closeModal"></div>
      <div class="modal-container" role="dialog" aria-modal="true" aria-label="网站公告">
        <div class="modal-header">
          <div>
            <h3>网站公告</h3>
            <p>长图可上下滚动查看完整内容，点击图片可放大查看</p>
          </div>
          <button type="button" class="close-btn" @click="closeModal" aria-label="关闭">
            ×
          </button>
        </div>

        <div class="scrollable-content">
          <img
            v-if="gonggao_img"
            :src="gonggao_img"
            alt="公告图片"
            class="announcement-image"
            @click="handleImageClick"
          />
          <div v-else class="announcement-empty">暂无公告内容</div>
        </div>

        <div class="modal-footer">
          <label class="dont-show-again">
            <input type="checkbox" v-model="dontShowAgain" />
            <span>不再显示此公告</span>
          </label>
          <div class="modal-footer-actions">
            <button type="button" class="view-full-btn" @click="handleImageClick">
              查看大图
            </button>
            <button type="button" class="confirm-btn" @click="closeModal">
              我知道了
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="mengban" v-if="userShows">
      <div class="userinfobox">
        <button
          type="button"
          class="user-close"
          @click="userShows = false"
          aria-label="关闭"
        >
          ×
        </button>
        <div class="user-header">
          <div class="user-avatar">定</div>
          <div>
            <h3>定制类人物</h3>
            <p>建议 15M 以内，支持 PSD 源文件，单文件不要超过 20M</p>
          </div>
        </div>
        <div class="infobox">
          <div class="infobox_item">
            <div class="input_box">
              <div class="input_name">会员ID</div>
              <el-input v-model="userinfo.id" disabled placeholder="">
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">素材类别</div>
              <el-input placeholder="" value="定制专属人物" disabled>
              </el-input>
            </div>
          </div>
          <div class="infobox_item">
            <div class="input_box">
              <div class="input_name">素材封面</div>
              <el-upload
                action="https://api.manmcz.com/index.php/api/home/uploadfile?type=1"
                :on-success="handleSuccess1"
              >
                <el-button type="primary">上传素材封面</el-button>
              </el-upload>
            </div>
            <div class="input_box">
              <div class="input_name">素材文件</div>
              <el-upload
                action="https://api.manmcz.com/index.php/api/home/uploadfile?type=2"
                :on-success="handleSuccess"
              >
                <el-button type="primary">上传素材psd文件</el-button>
              </el-upload>
            </div>
          </div>
          <div class="user-actions">
            <div class="baocun bgcolor" @click="insertuploadPsd()">保存设置</div>
          </div>
        </div>
      </div>
    </div>

    <div class="mengban" v-if="userShow">
      <div class="userinfobox">
        <button
          type="button"
          class="user-close"
          @click="userShow = false"
          aria-label="关闭"
        >
          ×
        </button>

        <div class="user-header">
          <div class="user-avatar">{{ (userinfo.display_name || "用").slice(0, 1) }}</div>
          <div>
            <h3>用户中心</h3>
            <p>管理账号信息与抖音授权</p>
          </div>
        </div>

        <div class="infobox">
          <div class="user-section-title">基本信息</div>
          <div class="infobox_item">
            <div class="input_box">
              <div class="input_name">会员ID</div>
              <el-input v-model="userinfo.id" disabled placeholder="">
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">注册时间</div>
              <el-input
                v-model="userinfo.user_registered"
                disabled
                placeholder=""
              >
              </el-input>
            </div>
          </div>
          <div class="infobox_item">
            <div class="input_box">
              <div class="input_name">昵称</div>
              <el-input v-model="userinfo.display_name" placeholder="请输入昵称">
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">邮箱账号</div>
              <el-input v-model="userinfo.user_email" disabled placeholder="">
              </el-input>
            </div>
          </div>
          <div class="infobox_item" v-if="userinfo.id == 57">
            <div class="input_box">
              <div class="input_name">用户邮箱</div>
              <el-input v-model="userinfo.save_user_id" placeholder="">
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">设置密码</div>
              <el-input v-model="userinfo.save_password" placeholder="">
              </el-input>
            </div>
          </div>

          <div class="tishi2">
            <strong>使用须知</strong>
            <p>
              凡使用星空素材网学员必须在漫迷文创机构使用，否则将进行责任追寻。
              <span>另抖音昵称及账号在抖音平台不允许修改。</span>
            </p>
          </div>

          <div class="user-section-title">抖音授权</div>
          <div class="infobox_item">
            <div class="input_box">
              <div class="input_name">抖音授权账号①</div>
              <el-input
                :disabled="douyin_name1 != ''"
                v-model="userinfo.douyin_name1"
                placeholder="请完善您的抖音账号①（格式为抖音名称+抖音ID）..."
              >
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">抖音授权账号②</div>
              <el-input
                :disabled="douyin_name2 != ''"
                v-model="userinfo.douyin_name2"
                placeholder="请完善您的抖音账号②（格式为抖音名称+抖音ID）..."
              >
              </el-input>
            </div>
          </div>
          <div class="infobox_item">
            <div class="input_box">
              <div class="input_name">抖音授权账号③</div>
              <el-input
                :disabled="douyin_name3 != ''"
                v-model="userinfo.douyin_name3"
                placeholder="请完善您的抖音账号③（格式为抖音名称+抖音ID）..."
              >
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">手机号码</div>
              <el-input
                v-model="userinfo.phone"
                placeholder="请输入您的手机号码..."
              >
              </el-input>
            </div>
          </div>
          <div class="user-actions">
            <div class="baocun bgcolor" @click="baocunUserinfo()">保存设置</div>
          </div>
        </div>
      </div>
    </div>

    <div class="mengban" v-if="moneyShow">
      <div class="recharge-tip-box">
        <button
          type="button"
          class="recharge-close"
          @click="moneyShow = false"
          aria-label="关闭"
        >
          ×
        </button>

        <div class="recharge-hero">
          <p class="recharge-kicker">XING KONG · GUIDE</p>
          <h3>购买指引</h3>
          <p class="recharge-lead">
            购买素材网账号，请按以下方式完成对接
          </p>
        </div>

        <div class="recharge-body">
          <div class="recharge-steps">
            <div class="recharge-step preferred">
              <div class="step-top">
                <span class="step-no">01</span>
                <em>推荐</em>
              </div>
              <h4>联系自己的师傅</h4>
              <p>优先找师傅协助办理，由师傅完成账号购买对接，更快捷也更稳妥。</p>
            </div>
            <div class="recharge-step">
              <div class="step-top">
                <span class="step-no">02</span>
                <em class="alt">备用</em>
              </div>
              <h4>右下角联系客服</h4>
              <p>若暂时联系不到师傅，可点击页面右下角「客服」扫码，由客服协助对接。</p>
            </div>
          </div>

          <div class="recharge-note">
            温馨提示：请勿通过不明渠道付款，避免账号与权益无法正常开通。
          </div>

          <button type="button" class="recharge-ok" @click="moneyShow = false">
            我知道了
          </button>
        </div>
      </div>
    </div>

    <div class="float-dock">
      <button
        type="button"
        class="float-btn float-recharge"
        @click="moneyShow = true"
        aria-label="充值"
      >
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1 14.5h-2v-1.2a3.4 3.4 0 0 1-2.2-.9l1.2-1.4a2.1 2.1 0 0 0 1.5.6c.6 0 1-.3 1-.7s-.5-.7-1.5-.7c-1.5 0-2.5-.8-2.5-2.1a2.3 2.3 0 0 1 2-2.2V7.5h2v1.1c.7.1 1.4.4 1.9.9l-1.2 1.3a1.7 1.7 0 0 0-1.2-.5c-.5 0-.9.3-.9.7s.5.7 1.6.7c1.6 0 2.5.8 2.5 2.2a2.4 2.4 0 0 1-2.1 2.3z"
          />
        </svg>
        <span>充值</span>
      </button>

      <div
        class="float-item float-kefu"
        @mouseenter="showQrcode = true"
        @mouseleave="showQrcode = false"
      >
        <button type="button" class="float-btn" aria-label="联系客服">
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
            <path
              fill="currentColor"
              d="M9.5 4C5.36 4 2 6.97 2 10.5c0 2.07 1.19 3.9 3.03 5.08L4.3 18.7l3.1-1.55c.67.18 1.37.3 2.1.35-.15-.48-.25-.98-.25-1.5C9.25 12.36 12.5 9.5 16.5 9.5c.34 0 .67.02 1 .06C16.84 6.2 13.5 4 9.5 4zm-2.75 3.75a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75zm5.5 0a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75zM16.5 11c-3.04 0-5.5 2.13-5.5 4.75S13.46 20.5 16.5 20.5c.55 0 1.08-.07 1.58-.2l2.27 1.13-.72-2.35C20.97 18.14 22 16.55 22 15.75 22 13.13 19.54 11 16.5 11zm-1.75 3a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm3.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"
            />
          </svg>
          <span>客服</span>
        </button>
        <div class="qrcode-popup" v-show="showQrcode">
          <img :src="kefuQrcode" alt="客服二维码" />
          <p>微信扫码添加客服</p>
        </div>
      </div>

      <button
        type="button"
        class="float-btn float-top"
        v-if="showScrollToTop"
        @click="scrollToTop"
        aria-label="回到顶部"
      >
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 4.5 5.5 11h4v8.5h5V11h4L12 4.5z"
          />
        </svg>
        <span>顶部</span>
      </button>
    </div>

    <RegisterAgreement
      v-model="agreementShow"
      @accept="isAgree = true"
    />
  </div>
</template>

<script setup>
import {
  register,
  login,
  getsortData,
  getData,
  getUserinfo,
  saveUserinfo,
  insertuploadpsds,
  index,
  peizhi,
} from "@/api/api.js";
import { ref, reactive, onMounted, onBeforeUnmount } from "vue";
import { useTheme } from "@/theme";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import kefuQrcode from "@/assets/kefu-qrcode.png";
import RegisterAgreement from "@/components/RegisterAgreement.vue";

const {
  themeState,
  accentOptions,
  toggleTheme,
  setAccent,
  togglePanel,
  closePanel,
} = useTheme();

const vClickOutside = {
  mounted(el, binding) {
    el.__clickOutsideHandler__ = (event) => {
      if (!el.contains(event.target)) {
        binding.value?.(event);
      }
    };
    // 延迟绑定，避免打开面板的同一次点击立刻关闭
    setTimeout(() => {
      document.addEventListener("click", el.__clickOutsideHandler__);
    }, 0);
  },
  unmounted(el) {
    document.removeEventListener("click", el.__clickOutsideHandler__);
    delete el.__clickOutsideHandler__;
  },
};
const backgroundImagePath = ref("/assets/index/indexbg.jpg");
const backgroundImagePath2 = ref("/assets/index/indexbg2.jpg");

const loginShow = ref(false);
const userShow = ref(false);
const userShows = ref(false);
const isLogin = ref(true);
const moneyShow = ref(false);

const showAnnouncement = ref(false);
const dontShowAgain = ref(false);

const handleImageClick = () => {
  window.open(gonggao_img.value, "_blank");
};

const closeModal = () => {
  if (dontShowAgain.value) {
    localStorage.setItem("hideAnnouncement", "true");
  }
  showAnnouncement.value = false;
};

const bannerList = ref([]);

const avatar_url = ref("");
const avatar_url2 = ref("");

const fenleiList = ref([
  {
    icon: "https://image.manmcz.com/wp-content/uploads/2024/12/202412230928593.png",
    name: "都市人物",
  },
  {
    icon: "http://image,manmcz.com/wp-content/uploads/2024/11/2024110709535254.png",
    name: "历史人物",
  },
]);
const searchValue1 = ref("");
const searchValue2 = ref("");
const sucaiList = reactive({
  data: [],
});
const dqId = ref(localStorage.getItem("dqId") || "");
const activeIndex = ref(localStorage.getItem("activeIndex") || -1);
const activeId = ref(localStorage.getItem("activeId") || "");
const username = ref("");
const gonggao_img = ref("");
const password = ref("");
const confirm_password = ref("");
const email = ref("");
const isAgree = ref(false);
const agreementShow = ref(false);
const isUserLogin = ref(localStorage.getItem("token"));
const categoryContainer = ref(null);

const login_btn = () => {
  if (username.value && password.value) {
    const formData = new FormData();
    formData.append("username", username.value);
    formData.append("password", password.value);

    login(formData).then((res) => {
      if (res.code === 100) {
        localStorage.setItem("token", res.data.token);
        ElMessage.success("登录成功");
        isUserLogin.value = res.data.token;
        loginShow.value = false;
      }
    });
  } else {
    ElMessage.error("用户名或密码不能为空");
  }
};

const register_btn = () => {
  if (!isAgree.value) {
    ElMessage.error("请先同意协议");
    return;
  }
  if (
    email.value &&
    username.value &&
    password.value &&
    confirm_password.value
  ) {
    if (password.value === confirm_password.value) {
      const formData = new FormData();
      formData.append("username", username.value);
      formData.append("password", password.value);
      formData.append("email", email.value);
      formData.append("confirm_password", confirm_password.value);
      register(formData).then((res) => {
        if (res.code === 100) {
          ElMessage.success("注册成功");
        }
      });
    } else {
      ElMessage.error("两次密码输入不一致");
    }
  } else {
    ElMessage.error("邮箱、用户名、密码不能为空");
  }
};

const userinfo = reactive({
  id: "",
  user_registered: "",
  display_name: "",
  user_email: "",
  phone: "",
  douyin_name1: "",
  douyin_name2: "",
  douyin_name3: "",
  save_user_id: "",
  save_password: "",
});
const douyin_name1 = ref("");
const douyin_name2 = ref("");
const douyin_name3 = ref("");

const openUserCenter = () => {
  getUserinfo(isUserLogin.value).then((res) => {
    if (res.code === 100) {
      userinfo.id = res.data.ID;
      userinfo.user_registered = res.data.user_registered;
      userinfo.display_name = res.data.display_name;
      userinfo.user_email = res.data.user_email;
      userinfo.phone = res.data.phone;
      userinfo.douyin_name1 = res.data.douyin_name1;
      douyin_name1.value = res.data.douyin_name1;
      userinfo.douyin_name2 = res.data.douyin_name2;
      douyin_name2.value = res.data.douyin_name2;
      userinfo.douyin_name3 = res.data.douyin_name3;
      douyin_name3.value = res.data.douyin_name3;
      userShow.value = true;
    }
  });
};

const handleSuccess = (response) => {
  avatar_url.value = response.data;
};

const handleSuccess1 = (response) => {
  avatar_url2.value = response.data;
};

const baocunUserinfo = () => {
  const formData = new FormData();
  formData.append("email", userinfo.user_email);
  formData.append("phone", userinfo.phone);
  formData.append("nickname", userinfo.display_name);
  formData.append("douyin_name1", userinfo.douyin_name1);
  formData.append("douyin_name2", userinfo.douyin_name2);
  formData.append("douyin_name3", userinfo.douyin_name3);
  formData.append("save_user_id", userinfo.save_user_id);
  formData.append("save_password", userinfo.save_password);
  formData.append("token", isUserLogin.value);

  saveUserinfo(formData).then((res) => {
    if (res.code === 100) {
      ElMessage.success("保存成功");
      userShow.value = false;
    }
  });
};

const insertuploadPsd = () => {
  const formData = new FormData();
  formData.append("avatar_url", avatar_url.value);
  formData.append("guid", avatar_url2.value);
  formData.append("token", isUserLogin.value);
  insertuploadpsds(formData).then((res) => {
    if (res.code === 100) {
      ElMessage.success("保存成功");
      userShows.value = false;
    }
  });
};

const setRemUnit = () => {
  const baseSize = 16;
  let scale = document.documentElement.clientWidth / 1920;

  if (document.documentElement.clientWidth <= 768) {
    scale = 0.3;
  }

  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 2) + "px";
};

const openUrl = (url) => {
  if (url) {
    window.open(url, "_blank");
  }
};

onMounted(() => {
  getLiebiao();
  setRemUnit();
  getIndex();
  getPeizhi();
  window.addEventListener("resize", setRemUnit);
  window.addEventListener("scroll", handleScroll);
});

const cunActiveIndex = (index, id) => {
  localStorage.setItem("activeIndex", index);
  localStorage.setItem("dqId", id);
};

const getIndex = () => {
  index().then((res) => {
    if (res.code == 100) {
      backgroundImagePath.value = res.data.background_image;
      backgroundImagePath2.value = res.data.canva_image[0].url;
      bannerList.value = res.data.banner_image;
      gonggao_img.value = res.data.gonggao_img;
      const hideAnnouncement = localStorage.getItem("hideAnnouncement");
      if (!hideAnnouncement) {
        setTimeout(() => {
          showAnnouncement.value = res.data.showAnnouncement;
        }, 15000);
      }
    }
  });
};

const qrcode_url2 = ref("");
const download_url = ref("");

const getPeizhi = () => {
  peizhi().then((res) => {
    if (res.code == 100) {
      download_url.value = res.data.software_download_url;
      qrcode_url2.value = res.data.customer_service_image;
    }
  });
};

const getLiebiao = async () => {
  try {
    const response = await getsortData();
    if (response.code === 1) {
      fenleiList.value = response.data;
      if (localStorage.getItem("activeIndex")) {
        getSucaiList(response.data[activeIndex.value].term_id);
        activeIndex.value = activeIndex.value;
      } else {
        getSucaiList(response.data[0].term_id);
        activeIndex.value = 0;
      }
    }
  } catch (error) {
    console.error("分类加载失败:", error);
  }
};

const getSucaiList = (id, page = 1) => {
  getData({
    sort_id: id ? id : dqId.value,
    limit: 24,
    page: page,
    name: searchValue2.value,
    token: isUserLogin.value,
  }).then((res) => {
    sucaiList.data = res.data;
  });
};

const searchSucaiList = (id, page = 1) => {
  searchValue2.value = searchValue1.value;
  getData({
    sort_id: id ? id : dqId.value,
    limit: 24,
    page: page,
    name: searchValue1.value,
  }).then((res) => {
    sucaiList.data = res.data;
  });
};

const router = useRouter();
const goCopyright = () => {
  router.push({ path: "/copyright" });
};
const tuDetail = (item) => {
  router.push({
    path: "/sucaiDetail",
    query: {
      id: item.id,
      image_cover: item.image_cover || "",
      post_content: item.post_content || "",
      post_title: item.post_title,
      is_model: item.is_model,
    },
  });
};

const tuichu = () => {
  localStorage.removeItem("token");
  isUserLogin.value = "";
};

const showScrollToTop = ref(false);
const showQrcode = ref(false);

const handleScroll = () => {
  showScrollToTop.value = window.scrollY > 300;
};

const selectCategory = (index, termId) => {
  activeIndex.value = index;
  searchValue1.value = "";
  searchValue2.value = "";
  getSucaiList(termId);
  dqId.value = termId;
  cunActiveIndex(index, termId);

  const container = categoryContainer.value;
  const item = container?.querySelectorAll(".category-item")[index];
  if (container && item) {
    const itemLeft = item.offsetLeft;
    const itemWidth = item.offsetWidth;
    const containerWidth = container.offsetWidth;
    container.scrollTo({
      left: itemLeft - (containerWidth - itemWidth) / 2,
      behavior: "smooth",
    });
  }
};

const scrollCategories = (direction) => {
  const container = categoryContainer.value;
  if (!container) return;
  const step = Math.max(container.clientWidth * 0.7, 280);
  container.scrollBy({
    left: direction * step,
    behavior: "smooth",
  });
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const scrollToGallery = () => {
  document.getElementById("gallery")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
  window.removeEventListener("resize", setRemUnit);
});
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  color: var(--xk-ink);
  background: var(--xk-page-bg);
  overflow-x: hidden;
  transition: color 0.25s ease, background 0.25s ease;
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(14px);
  background: var(--xk-topbar-bg);
  border-bottom: 1px solid transparent;
  transition: border-color 0.25s ease, background 0.25s ease;

  &.scrolled {
    border-bottom-color: var(--xk-line);
  }
}

.topbar-inner {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0.7rem clamp(1rem, 2.2vw, 2rem);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  text-decoration: none;
  color: var(--xk-ink);
  flex-shrink: 0;
  min-width: 0;
}

.brand-mark {
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  object-fit: cover;
  display: block;
  box-shadow: 0 4px 12px rgba(11, 120, 196, 0.18);
  background: #0b1220;
}

.brand-copy {
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
  line-height: 1.1;
}

.brand-text {
  font-family: "ZCOOL KuaiLe", "Noto Sans SC", sans-serif;
  font-size: 1.28rem;
  letter-spacing: 0.04em;
}

.brand-sub {
  font-size: 0.68rem;
  color: var(--xk-muted);
  letter-spacing: 0.12em;
}

.top-nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.55rem 0.65rem;
}

.nav-group {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.15rem;
  border-radius: 0.75rem;
  background: color-mix(in srgb, var(--xk-soft) 72%, transparent);
}

.nav-divider {
  width: 1px;
  height: 1.15rem;
  background: var(--xk-line);
  opacity: 0.9;
}

.nav-link {
  border: none;
  cursor: pointer;
  font: inherit;
  font-size: 0.88rem;
  padding: 0.42rem 0.78rem;
  border-radius: 0.55rem;
  transition: background 0.2s ease, color 0.2s ease;
  background: transparent;
  color: var(--xk-ink);
  white-space: nowrap;

  &:hover {
    background: var(--xk-panel-bg);
    color: var(--xk-sky-deep);
  }
}

.nav-quiet {
  color: var(--xk-muted);

  &:hover {
    color: var(--xk-ink);
  }
}

.nav-login {
  border: none;
  cursor: pointer;
  font: inherit;
  font-size: 0.88rem;
  font-weight: 600;
  padding: 0.42rem 0.95rem;
  border-radius: 0.55rem;
  background: linear-gradient(90deg, var(--xk-sky-deep), var(--xk-sky));
  color: #fff;
  white-space: nowrap;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 18px rgba(11, 120, 196, 0.28);
  }
}

.theme-switch {
  position: relative;
}

.theme-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: 1px solid var(--xk-line);
  cursor: pointer;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.4rem 0.7rem 0.4rem 0.55rem;
  border-radius: 999px;
  background: var(--xk-panel-bg);
  color: var(--xk-ink);
  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease;

  &:hover {
    border-color: color-mix(in srgb, var(--xk-sky) 45%, var(--xk-line));
    color: var(--xk-sky-deep);
  }
}

.theme-chip-dot {
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--xk-sky), var(--xk-sky-deep));
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--xk-sky) 22%, transparent);
}

.theme-panel {
  position: absolute;
  top: calc(100% + 0.45rem);
  right: 0;
  width: 220px;
  padding: 0.85rem;
  border-radius: 0.9rem;
  background: var(--xk-panel-bg);
  border: 1px solid var(--xk-line);
  box-shadow: 0 14px 32px rgba(15, 40, 70, 0.16);
  z-index: 120;
}

.theme-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;

  span {
    font-size: 0.82rem;
    color: var(--xk-muted);
    flex-shrink: 0;
  }

  &.accents {
    margin-top: 0.85rem;
    align-items: flex-start;
  }
}

.mode-btn {
  border: 1px solid var(--xk-line);
  background: var(--xk-soft);
  color: var(--xk-sky-deep);
  font: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.35rem 0.65rem;
  border-radius: 0.5rem;
  cursor: pointer;
}

.accent-list {
  display: flex;
  gap: 0.45rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.accent-dot {
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);

  &.active {
    border-color: var(--xk-ink);
    transform: scale(1.08);
  }
}

.hero {
  position: relative;
  min-height: min(78vh, 640px);
  width: 100%;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
}

.hero-veil {
  position: absolute;
  inset: 0;
  background: var(--xk-hero-veil);
}

.hero-orbit {
  position: absolute;
  width: 42rem;
  height: 42rem;
  right: -12rem;
  top: -16rem;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.18);
  animation: orbitPulse 8s ease-in-out infinite;
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: min(1760px, 98vw);
  width: 100%;
  margin: 0 auto;
  padding: 4.5rem 1.25rem 3.5rem;
  color: #fff;
  animation: riseIn 0.8s ease both;
}

.hero-kicker {
  font-size: 0.85rem;
  letter-spacing: 0.28em;
  opacity: 0.85;
  margin-bottom: 0.75rem;
}

.hero-title {
  font-family: "ZCOOL KuaiLe", "Noto Sans SC", sans-serif;
  font-size: clamp(2.8rem, 7vw, 4.8rem);
  line-height: 1.05;
  font-weight: 400;
  margin-bottom: 0.85rem;
  text-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
}

.hero-desc {
  font-size: clamp(1rem, 2vw, 1.2rem);
  opacity: 0.92;
  max-width: 28rem;
  margin-bottom: 1.75rem;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.btn-primary,
.btn-ghost {
  border: none;
  cursor: pointer;
  font: inherit;
  font-size: 1rem;
  padding: 0.85rem 1.45rem;
  border-radius: 0.7rem;
  transition: transform 0.2s ease, background 0.2s ease;
}

.btn-primary {
  background: #fff;
  color: var(--xk-sky-deep);

  &:hover {
    transform: translateY(-2px);
  }
}

.btn-ghost {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.35);

  &:hover {
    background: rgba(255, 255, 255, 0.24);
  }
}

.main {
  max-width: min(1760px, 98vw);
  margin: 0 auto;
  padding: 0 1rem 3rem;
}

.section {
  margin-top: 2.25rem;
}

.section-head {
  margin-bottom: 1.25rem;

  h2 {
    font-family: "ZCOOL KuaiLe", "Noto Sans SC", sans-serif;
    font-size: 1.75rem;
    font-weight: 400;
    margin-bottom: 0.35rem;
    color: var(--xk-ink);
  }

  p {
    color: var(--xk-muted);
    font-size: 0.95rem;
  }

  &.row {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
  }
}

.category-panel {
  position: relative;
  background: var(--xk-panel-bg);
  border: 1px solid var(--xk-line);
  border-radius: 1.25rem;
  padding: 0.85rem 2.6rem;
  box-shadow: 0 12px 32px rgba(11, 120, 196, 0.05);
}

.cat-head {
  align-items: flex-end;
}

.cat-current {
  font-size: 0.9rem;
  color: var(--xk-muted);
  padding: 0.45rem 0.85rem;
  border-radius: 0.65rem;
  background: var(--xk-paper);
  border: 1px solid var(--xk-line);

  strong {
    color: var(--xk-sky-deep);
    font-weight: 600;
  }
}

.cat-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  width: 2rem;
  height: 2rem;
  border: 1px solid var(--xk-line);
  border-radius: 0.55rem;
  background: var(--xk-paper);
  color: var(--xk-sky-deep);
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: background 0.2s ease, transform 0.2s ease;

  &:hover {
    background: var(--xk-mist);
  }
}

.cat-arrow-left {
  left: 0.45rem;
}

.cat-arrow-right {
  right: 0.45rem;
}

.category-nav-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: rgba(11, 120, 196, 0.35) transparent;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(11, 120, 196, 0.35);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.category-list {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.7rem;
  width: max-content;
  padding: 0.25rem 0.15rem 0.55rem;
}

.category-item {
  position: relative;
  flex: 0 0 auto;
  width: 6.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.55rem;
  padding: 0.85rem 0.45rem 0.7rem;
  border: 1px solid transparent;
  background: var(--xk-soft);
  border-radius: 1rem;
  cursor: pointer;
  color: var(--xk-ink);
  font: inherit;
  transition:
    transform 0.22s ease,
    border-color 0.22s ease,
    background 0.22s ease,
    box-shadow 0.22s ease;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0.35rem;
    width: 0;
    height: 3px;
    border-radius: 2px;
    background: linear-gradient(90deg, var(--xk-sky-deep), var(--xk-sky));
    transform: translateX(-50%);
    transition: width 0.22s ease;
  }

  &:hover {
    transform: translateY(-2px);
    background: var(--xk-paper);
    border-color: var(--xk-line);
    box-shadow: 0 8px 18px rgba(11, 120, 196, 0.08);
  }

  &.active {
    background: var(--xk-paper);
    border-color: var(--xk-line);
    box-shadow: 0 10px 22px rgba(11, 120, 196, 0.12);

    &::after {
      width: 1.6rem;
    }

    .category-icon-wrap {
      border-color: var(--xk-sky);
      box-shadow: 0 0 0 3px rgba(26, 155, 232, 0.18);
    }

    .category-name {
      color: var(--xk-sky-deep);
      font-weight: 600;
    }
  }
}

.category-icon-wrap {
  width: 4.25rem;
  height: 4.25rem;
  border-radius: 50%;
  background: linear-gradient(160deg, #e8f6fd 0%, #f4f8fb 100%);
  border: 2px solid transparent;
  display: grid;
  place-items: center;
  overflow: hidden;
  transition: border-color 0.22s ease, box-shadow 0.22s ease;
}

.category-icon {
  width: 3.2rem;
  height: 3.2rem;
  object-fit: contain;
  border-radius: 50%;
}

.category-name {
  font-size: 0.86rem;
  font-weight: 500;
  text-align: center;
  line-height: 1.25;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.15rem 0.2rem;
}

.searchbox {
  flex: 1;
  min-width: min(100%, 320px);
  max-width: 460px;
  height: 3.15rem;
  padding: 0.25rem 0.25rem 0.25rem 0.95rem;
  display: flex;
  align-items: center;
  gap: 0.55rem;
  background: var(--xk-paper);
  border: 1px solid var(--xk-line);
  border-radius: 0.9rem;
  box-shadow: 0 10px 28px rgba(11, 120, 196, 0.06);

  .search-icon {
    color: var(--xk-sky);
    flex-shrink: 0;
  }

  input {
    border: none;
    outline: none;
    background: transparent;
    width: 100%;
    height: 100%;
    font: inherit;
    font-size: 0.95rem;
    color: var(--xk-ink);
  }

  input::placeholder {
    color: var(--xk-muted);
  }
}

.search-btn {
  border: none;
  cursor: pointer;
  font: inherit;
  height: 100%;
  padding: 0 1.15rem;
  border-radius: 0.7rem;
  background: linear-gradient(90deg, var(--xk-sky-deep), var(--xk-sky));
  color: #fff;
  white-space: nowrap;
}

.sucaiList2 {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 1.15rem;
}

.waterfall_item2 {
  cursor: pointer;
  border-radius: 1rem;
  overflow: hidden;
  background: var(--xk-card-bg);
  border: 1px solid var(--xk-line);
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 32px rgba(11, 120, 196, 0.12);

    .material-image :deep(img),
    :deep(.el-image__inner) {
      transform: scale(1.03);
    }
  }
}

.card-media {
  position: relative;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  background: linear-gradient(160deg, #eaf6fd, #f7f9fb);
}

.material-image {
  width: 100%;
  height: 100%;

  :deep(img),
  :deep(.el-image__inner) {
    width: 100%;
    height: 100%;
    object-fit: contain;
    image-rendering: -webkit-optimize-contrast;
    transition: transform 0.35s ease;
  }
}

.card-tag {
  position: absolute;
  left: 0.65rem;
  top: 0.65rem;
  font-size: 0.72rem;
  padding: 0.2rem 0.5rem;
  border-radius: 0.35rem;
  color: #fff;
  background: rgba(23, 50, 74, 0.55);

  &.vip {
    background: var(--xk-coral);
  }
}

.card-title {
  margin: 0;
  padding: 0.7rem 0.75rem 0.85rem;
  font-size: 0.88rem;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--xk-ink);

  &.vip {
    color: #d97706;
  }
}

.empty-state {
  padding: 3rem 1rem;
  text-align: center;
  color: var(--xk-muted);
  background: var(--xk-soft);
  border-radius: 1rem;
  border: 1px dashed var(--xk-line);
}

.fenye {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
}

.fenye-box {
  display: inline-flex;
  align-items: center;
  padding: 0.65rem 1rem;
  background: var(--xk-panel-bg);
  border: 1px solid var(--xk-line);
  border-radius: 0.9rem;
  box-shadow: 0 8px 24px rgba(11, 120, 196, 0.06);

  :deep(.el-pagination) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.15rem;
  }

  :deep(.el-pagination.is-background .el-pager li.is-active) {
    background: linear-gradient(90deg, var(--xk-sky-deep), var(--xk-sky));
  }

  :deep(.el-pagination__total) {
    color: var(--xk-muted);
    margin-right: 0.75rem;
  }

  :deep(.el-pagination__jump) {
    margin-left: 0.65rem;
    color: var(--xk-muted);
  }

  :deep(.el-pagination__editor.el-input) {
    width: 3.2rem;
    margin: 0 0.35rem;
  }

  :deep(.el-pagination__editor .el-input__inner) {
    height: 28px;
    text-align: center;
  }
}

.banner-section {
  :deep(.el-carousel) {
    border-radius: 1rem;
    overflow: hidden;
  }
}

.site-footer {
  margin-top: 2.5rem;
  background: var(--xk-footer-bg);
  color: var(--xk-footer-text);
  width: 100%;
  border-top: 1px solid var(--xk-footer-line);
}

.footer-inner {
  max-width: min(980px, 94vw);
  margin: 0 auto;
  padding: 1.6rem 1rem 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  text-align: center;
}

.footer-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
}

.footer-name {
  font-family: "ZCOOL KuaiLe", "Noto Sans SC", sans-serif;
  font-size: 1.15rem;
  font-weight: 400;
  letter-spacing: 0.04em;
  color: var(--xk-footer-title);
}

.footer-main p {
  margin: 0;
  max-width: 28rem;
  line-height: 1.6;
  font-size: 0.88rem;
  color: var(--xk-footer-text);
}

.footer-legal {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.35rem 0.55rem;
  font-size: 0.8rem;
  color: var(--xk-footer-muted);
  padding-top: 0.75rem;
  border-top: 1px solid var(--xk-footer-line);
  width: min(100%, 36rem);

  a {
    color: var(--xk-footer-link);
    text-decoration: none;

    &:hover {
      color: var(--xk-sky);
    }
  }

  .dot {
    opacity: 0.55;
  }
}

.float-dock {
  position: fixed;
  right: 1.25rem;
  bottom: 1.5rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.recharge-tip-box {
  position: relative;
  width: min(460px, calc(100vw - 32px));
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 24px 56px rgba(15, 40, 70, 0.28);
  animation: riseIn 0.35s ease both;
}

.recharge-close {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 2;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  backdrop-filter: blur(4px);
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.34);
  }
}

.recharge-hero {
  padding: 28px 28px 22px;
  text-align: left;
  color: #fff;
  background:
    radial-gradient(ellipse 80% 90% at 100% 0%, rgba(255, 255, 255, 0.22), transparent 50%),
    linear-gradient(135deg, #0b78c4 0%, #1a9be8 48%, #3eb6f5 100%);
}

.recharge-kicker {
  margin: 0 0 8px;
  font-size: 0.72rem;
  letter-spacing: 0.18em;
  opacity: 0.85;
}

.recharge-hero h3 {
  margin: 0 0 8px;
  font-family: "ZCOOL KuaiLe", "Noto Sans SC", sans-serif;
  font-size: 1.85rem;
  font-weight: 400;
  line-height: 1.2;
  color: #fff;
}

.recharge-lead {
  margin: 0;
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.92rem;
  line-height: 1.55;
}

.recharge-body {
  padding: 18px 20px 20px;
  background: var(--xk-panel-bg);
}

.recharge-steps {
  display: grid;
  gap: 12px;
  margin-bottom: 14px;
}

.recharge-step {
  text-align: left;
  padding: 14px 14px 15px;
  border-radius: 14px;
  background: var(--xk-soft);
  border: 1px solid var(--xk-line);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &.preferred {
    background: var(--xk-mist);
    border-color: var(--xk-line);
    box-shadow: 0 8px 20px rgba(11, 120, 196, 0.08);
  }

  h4 {
    margin: 0 0 6px;
    font-size: 1rem;
    color: var(--xk-ink);
    font-weight: 700;
  }

  p {
    margin: 0;
    font-size: 0.88rem;
    line-height: 1.6;
    color: var(--xk-muted);
  }
}

.step-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.step-no {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.1rem;
  height: 1.55rem;
  padding: 0 0.45rem;
  border-radius: 0.45rem;
  background: rgba(11, 120, 196, 0.12);
  color: #0b78c4;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.step-top em {
  font-style: normal;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.18rem 0.5rem;
  border-radius: 0.4rem;
  background: linear-gradient(90deg, #0b78c4, #1a9be8);
  color: #fff;

  &.alt {
    background: rgba(23, 50, 74, 0.08);
    color: #5a7084;
  }
}

.recharge-note {
  margin-bottom: 14px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #fff8f0;
  border: 1px solid rgba(232, 160, 70, 0.28);
  color: #9a6a2e;
  font-size: 0.8rem;
  line-height: 1.55;
  text-align: left;
}

.recharge-ok {
  width: 100%;
  border: none;
  cursor: pointer;
  font: inherit;
  font-size: 0.98rem;
  font-weight: 600;
  height: 44px;
  border-radius: 12px;
  color: #fff;
  background: linear-gradient(90deg, #0b78c4, #1a9be8);
  box-shadow: 0 10px 22px rgba(11, 120, 196, 0.28);
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }
}

.float-item {
  position: relative;
}

.float-btn {
  width: 3.4rem;
  min-height: 3.4rem;
  border: 1px solid var(--xk-line);
  border-radius: 1rem;
  background: var(--xk-panel-bg);
  color: var(--xk-sky-deep);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  padding: 0.45rem 0.3rem;
  box-shadow: 0 10px 24px rgba(23, 50, 74, 0.12);
  transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

  span {
    font-size: 0.68rem;
    line-height: 1;
    font-weight: 600;
    letter-spacing: 0.02em;
  }

  &:hover {
    transform: translateY(-2px);
    background: linear-gradient(160deg, var(--xk-sky-deep), var(--xk-sky));
    color: #fff;
    border-color: transparent;
    box-shadow: 0 14px 28px rgba(11, 120, 196, 0.28);
  }
}

.float-recharge {
  background: linear-gradient(160deg, var(--xk-sky-deep), var(--xk-sky));
  color: #fff;
  border-color: transparent;
  box-shadow: 0 12px 26px rgba(11, 120, 196, 0.28);

  &:hover {
    box-shadow: 0 16px 30px rgba(11, 120, 196, 0.36);
  }
}

.float-kefu:hover .float-btn,
.float-kefu:focus-within .float-btn {
  background: linear-gradient(160deg, var(--xk-sky-deep), var(--xk-sky));
  color: #fff;
  border-color: transparent;
}

.qrcode-popup {
  position: absolute;
  right: calc(100% + 0.75rem);
  bottom: 0;
  width: 10.5rem;
  padding: 0.75rem;
  background: #fff;
  border: 1px solid rgba(11, 120, 196, 0.12);
  border-radius: 0.9rem;
  box-shadow: 0 14px 32px rgba(23, 50, 74, 0.16);
  text-align: center;

  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 0.45rem;
  }

  p {
    margin: 0.55rem 0 0;
    font-size: 0.75rem;
    color: rgba(23, 50, 74, 0.65);
  }

  &::after {
    content: "";
    position: absolute;
    right: -6px;
    bottom: 1.2rem;
    width: 10px;
    height: 10px;
    background: #fff;
    border-right: 1px solid rgba(11, 120, 196, 0.12);
    border-top: 1px solid rgba(11, 120, 196, 0.12);
    transform: rotate(45deg);
  }
}

@media (max-width: 720px) {
  .footer-inner {
    padding: 1.35rem 1rem 1.2rem;
  }

  .footer-name {
    font-size: 1.05rem;
  }

  .footer-legal {
    flex-direction: column;
    gap: 0.35rem;

    .dot {
      display: none;
    }
  }
}

@media (max-width: 640px) {
  .float-dock {
    right: 0.85rem;
    bottom: 1rem;
  }

  .float-btn {
    width: 3rem;
    min-height: 3rem;
    border-radius: 0.85rem;

    span {
      font-size: 0.62rem;
    }
  }

  .qrcode-popup {
    width: 9.2rem;
  }
}

@keyframes riseIn {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes orbitPulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.45;
  }
  50% {
    transform: scale(1.06);
    opacity: 0.75;
  }
}

@media (max-width: 1200px) {
  .sucaiList2 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .sucaiList2 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.85rem;
  }

  .hero {
    min-height: min(70vh, 520px);
  }
}

@media (max-width: 640px) {
  .topbar-inner {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .top-nav {
    width: 100%;
    justify-content: flex-start;
  }

  .nav-divider {
    display: none;
  }

  .nav-group {
    background: transparent;
    padding: 0;
  }

  .brand-sub {
    display: none;
  }

  .sucaiList2 {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.7rem;
  }

  .hero-content {
    padding: 3.5rem 1rem 2.5rem;
  }

  .category-panel {
    padding: 0.7rem 2.1rem;
  }

  .category-item {
    width: 5.5rem;
    padding: 0.7rem 0.3rem 0.6rem;
  }

  .category-icon-wrap {
    width: 3.4rem;
    height: 3.4rem;
    border-radius: 50%;
  }

  .category-icon {
    width: 2.45rem;
    height: 2.45rem;
    border-radius: 50%;
  }

  .category-name {
    font-size: 0.75rem;
  }

  .cat-current {
    width: 100%;
    text-align: center;
  }
}
</style>

<style scoped>
.announcement-modal {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  padding: 16px;
  box-sizing: border-box;
}

.modal-overlay {
  position: absolute;
  inset: 0;
  background: rgba(8, 24, 40, 0.52);
  backdrop-filter: blur(2px);
}

.modal-container {
  position: relative;
  z-index: 1;
  width: min(920px, 100%);
  height: min(88vh, 900px);
  max-height: 88vh;
  background: var(--xk-panel-bg);
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 56px rgba(15, 40, 70, 0.28);
}

.modal-header {
  position: relative;
  flex-shrink: 0;
  padding: 16px 52px 14px 20px;
  background: var(--xk-soft);
  border-bottom: 1px solid var(--xk-line);
}

.modal-header h3 {
  margin: 0 0 4px;
  color: var(--xk-ink);
  font-size: 1.05rem;
  font-weight: 700;
}

.modal-header p {
  margin: 0;
  font-size: 0.8rem;
  color: var(--xk-muted);
  line-height: 1.4;
}

.scrollable-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 12px 16px;
  background: var(--xk-mist);
  overscroll-behavior: contain;
}

.scrollable-content::-webkit-scrollbar {
  width: 8px;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background: rgba(11, 120, 196, 0.35);
  border-radius: 4px;
}

.announcement-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
  background: #fff;
  cursor: zoom-in;
  box-shadow: 0 6px 18px rgba(23, 50, 74, 0.08);
}

.announcement-empty {
  padding: 3rem 1rem;
  text-align: center;
  color: #8091a2;
}

.modal-footer {
  flex-shrink: 0;
  padding: 12px 16px;
  background: var(--xk-panel-bg);
  border-top: 1px solid var(--xk-line);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.dont-show-again {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: var(--xk-muted);
  cursor: pointer;
  user-select: none;
}

.dont-show-again input {
  margin-right: 8px;
}

.modal-footer-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.view-full-btn,
.confirm-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
}

.view-full-btn {
  background: var(--xk-soft);
  color: var(--xk-sky);
  border: 1px solid var(--xk-line);
}

.confirm-btn {
  background: linear-gradient(90deg, var(--xk-sky-deep), var(--xk-sky));
  color: #fff;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 30px;
  height: 30px;
  background: var(--xk-soft);
  color: var(--xk-ink);
  border: none;
  border-radius: 50%;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: var(--xk-line);
}

@media (max-width: 640px) {
  .announcement-modal {
    padding: 10px;
  }

  .modal-container {
    height: min(92vh, 900px);
    max-height: 92vh;
    border-radius: 12px;
  }

  .modal-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .modal-footer-actions {
    margin-left: 0;
    width: 100%;
  }

  .view-full-btn,
  .confirm-btn {
    flex: 1;
  }
}
</style>
